export const industryOptions =  [
    { key: 'professional_services', value: 'PROFESSIONAL', text: 'Professional Services' },
    { key: 'real_estate', value: 'REAL_ESTATE', text: 'Real Estate' },
    { key: 'healthcare_and_life_sciences', value: 'HEALTHCARE', text: 'Healthcare and Life Sciences' },
    { key: 'hr_staffing_or_recruitment', value: 'HUMAN_RESOURCES', text: 'HR, Staffing or Recruitment' },
    { key: 'energy_and_utilities', value: 'ENERGY', text: 'Energy and Utilities' },
    { key: 'retail_and_consumer', value: 'RETAIL', text: 'Retail and Consumer' },
    { key: 'products', value: 'products', text: 'Products' }, //
    { key: 'transportation_or_logistics', value: 'TRANSPORTATION', text: 'Transportation or Logistics' },
    { key: 'agriculture', value: 'AGRICULTURE', text: 'Agriculture' },
    { key: 'insurance', value: 'INSURANCE', text: 'Insurance' },
    { key: 'postal_and_delivery', value: 'POSTAL', text: 'Postal and Delivery' },
    { key: 'education', value: 'EDUCATION', text: 'Education' },
    { key: 'hospitality_and_travel', value: 'HOSPITALITY', text: 'Hospitality and Travel' },
    { key: 'financial_services', value: 'FINANCIAL', text: 'Financial Services' },
    { key: 'political', value: 'POLITICAL', text: 'Political' },
    { key: 'gambling_and_lottery', value: 'GAMBLING', text: 'Gambling and Lottery' },
    { key: 'legal', value: 'LEGAL', text: 'Legal' },
    { key: 'constuction_materials_and_services', value: 'CONSTRUCTION', text: 'Construction Materials and Trade Services' },
    { key: 'non_profitable_organization', value: 'non_profitable_organization', text: 'Non-Profitable Organization' }, //
    { key: 'manufacturing', value: 'MANUFACTURING', text: 'Manufacturing' },
    { key: 'goverment_service_and_agencies', value: 'GOVERNMENT', text: 'Goverment Service and Agencies' },
    { key: 'information_technology_services', value: 'TECHNOLOGY', text: 'Information Technology Services' },
    { key: 'media_and_communication', value: 'COMMUNICATION', text: 'Media and Communication' },
]

export const alternativeBusinessTypeOptions = [
    { key: 'none', value: 'NONE', text: 'None' },
    { key: 'duns', value: 'DUNS', text: 'DUNS' },
    { key: 'giin', value: 'GIIN', text: 'GIIN' },
    { key: 'lei', value: 'LEI', text: 'LEI' }
]